// @flow
import React, { PureComponent } from 'react';
import WeekMatchResultContainer from 'containers/match/WeekMatchResultContainer';
import ButtonIcon from '../fragments/button/ButtonIcon';
import CompetitionRow from './CompetitionRow';
import CardCompetition from '../fragments/card/CardCompetition';
import type { CompetitionLayoutType } from 'types/CompetitionLayout';
import { TYPE_TERRITORIAL, TYPE_FEDERAL } from 'constants/competitionsConstants';
import { getUniqueSortedDivisions } from 'utils/competitionsUtils';
import { getCompetitionsWithType } from 'utils/competitionsUtils';
import LazyLoad from 'components/fragments/LazyLoad';

export type StateProps = {
  // $FlowFixMe
  competitions: Array<CompetitionLayoutType>,
  ligue: number,
};

export type DispatchProps = {
  fetchCompetitions: (ligue: number) => void
};

type Props = StateProps & DispatchProps;

class CompetitionHub extends PureComponent<Props> {
  props: Props;
  static defaultProps = {
    competitions: []
  };

  componentDidMount() {
    if (parseInt(this.props.ligue, 10) > 0) {
      this.props.fetchCompetitions(this.props.ligue);
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.ligue !== prevProps.ligue) {
      this.props.fetchCompetitions(this.props.ligue);
    }
  }

  displayShowCompetitions = () => {
    return (
      <ButtonIcon
        url="/competitions"
        icon="icon-shield is-inline"
        isPrimary={true}
        isFull={true}
        noIcon={true}
        label="Voir toutes les compétitions"
        withLabel={true}
        titleSEO="Se rendre sur le site FFR competitions"
      />
    );
  };

  renderCompetitionsRow = (rows: Array<CompetitionLayoutType>): any => {
    return rows.map((row, index) => {
      return <CompetitionRow key={row.division} slug={row.slug} title={row.division} results={row.nouveaux_resultats} />;
    });
  };

  render() {
    const divisions = getUniqueSortedDivisions(this.props.competitions);
    const territorial = getCompetitionsWithType(divisions, TYPE_TERRITORIAL, true);
    const dispayedTerritorial: Array<CompetitionLayoutType> = territorial.slice(0, 4);
    const federal = getCompetitionsWithType(divisions, TYPE_FEDERAL, true);
    const displayedFederal: Array<CompetitionLayoutType> = federal.slice(0, 4);

    return (
      <>
        <section className="container">
          <h2 className="mb-3">Compétitions de la ligue</h2>
        </section>
        <LazyLoad>
          <section className="container home-competition">
            <div className="home-competition__wrapper">
              <div className="row">
                <div className="col col-md-6 col-lg-3">
                  <WeekMatchResultContainer />
                </div>
                <div className="col col-md-6 col-lg-3 home-competition__territorial">
                  <h5 className="mb-3">Territoriales</h5>
                  {this.renderCompetitionsRow(dispayedTerritorial)}
                  {dispayedTerritorial.length === 0 &&
                  <div className="placeholder">
                    <p>
                      <i className="icon icon-ball"></i>
                      <br />
                      <strong className="ft-h5">Aucune compétition</strong>
                      <br />Pas de compétitions disponibles pour cette saison pour le moment
                    </p>
                  </div>
                  }
                  {territorial.length > 4 && this.displayShowCompetitions()}
                </div>
                <div className="col col-md-12 col-lg-3 home-competition__federal">
                  <h5 className="mb-3">Fédérales</h5>
                  {this.renderCompetitionsRow(displayedFederal)}
                  {displayedFederal.length === 0 &&
                  <div className="placeholder">
                    <p>
                      <i className="icon icon-ball"></i>
                      <br />
                      <strong className="ft-h5">Aucune compétition</strong>
                      <br />Pas de compétitions disponibles pour cette saison pour le moment
                    </p>
                  </div>
                  }
                  {federal.length > 4 && this.displayShowCompetitions()}
                </div>
                <CardCompetition isHomePage={true} />
              </div>
            </div>
          </section>
        </LazyLoad>
      </>
    );
  }
}

export default CompetitionHub;
